import { Pipe, PipeTransform } from '@angular/core';
import { LegalDateTimeService } from '../services/legal-datetime.service';

@Pipe({
  name: 'legalDate'
})
export class LegalDatePipe implements PipeTransform {
  constructor(private legalDate: LegalDateTimeService) {}

  transform(value: string | number | Date | null | undefined, pattern = 'DD/MM/YYYY'): string {
    return this.legalDate.format(value, pattern);
  }
}
